<template>
  <div class="group_mvp_reward_list" :style="{background: loading ? 'transparent': '#fff'}" v-if="meanfulGlobalParams">
    <div class="list-wraper">
      <rich-recycle-list class="list" v-if="!emptyStatus" :size="size" :on-fetch="onFetchlist" :offset="offset">
        <template slot="item" slot-scope="{ data }" class="list-itm">
          <rich-cell
            :class="itmCls(data)"
            :id="data.nickName"
            @click="() => {}"
            :title="data.nickName"
            :value="formatSubtext(data.amountSplit, data.info, data)"
          >
          <img slot="icon" :src="data.headImg !== '' ? data.headImg : defaultHeadImg" width="24" height="24" class="headImg" v-if="data.headImg">
          <img slot="icon" src="@/assets/images/xtc/headimg@2x.png" width="24" height="24" class="headImg" v-else>
          <span slot="icon" class="label">{{(+data.rewardStatus !== 2) ? (data.info || data.rewardTimeDisplay) : ''}}</span>
          <!-- (+data.rewardStatus !== 2) ? (data.info || data.rewardTimeDisplay) : '' -->
          </rich-cell>
        </template>
      </rich-recycle-list>
      <div class="empty-status" v-else>
        <img src="../../../../assets/images/xtc/empty.png" />
        <p class="empty-title">{{$t('FoodC_all_No_reward_ocGJ')}}</p>
        <p class="empty-explain">{{$t('FoodC_all_You_haven_lSmt')}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/styles/main.scss";
export default {
  props: {
    emptyStatus: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    offset: {
      type: Number,
      default: 1
    },
    onFetchlist: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      defaultHeadImg: require('../../../../assets/images/xtc/headimg@2x.png')
    }
  },
  computed: {
    meanfulGlobalParams () {
      // return this.globalParams && this.globalParams.token
      return {}
    }
  },
  methods: {
    itmCls (data) {
      // switch (data.rewardStatus) {
      //   case 1: return 'itm-black'
      //   case 0: return 'itm-grey'
      //   default: return 'itm-red'
      // }
      let cls = 'itm-black'
      if (data.rewardStatus !== 2) {
        cls += ' label-cell'
      }
      if (data.rewardStatus !== 0) {
        cls += ' label-cell-lower'
      }
      return cls
    },
    formatSubtext (amountSplit, subText, obj) {
      let resultText = ''
      if (+obj.rewardStatus === 0) { // 未奖励 = 接受邀请
        // resultText = resultText + this.gettext('待入账')
        resultText = this.$t('FoodC_Notifications_Accept_the_wTgP' /** 接受邀请 */)
      } else if (+obj.rewardStatus === 1) { // 已经奖励 = 已完成
        // resultText = resultText + ''
        resultText = this.$t('FoodC_Notifications_Completed_pEhY' /** 已完成 */)
      } else {
        resultText = this.gettext('已过期')
      }
      return resultText
    }
  }
}
</script>
<style scoped lang="stylus">
@import "~@/common/stylus/base"
@import "~@/common/stylus/variables";
@import '~@/common/stylus/mixin.styl';
.group_mvp_reward_list {
  margin 20px 24px 40px
  height calc(100% - 64px)
  background #ffffff
  padding 0 32px
  overflow hidden
  .headImg {
    position: absolute
    left: 0
    top: 22px
    width: 80px
    height: 80px
    border-radius: 331px;
    background: url("~@/assets/images/xtc/headimg@2x.png") no-repeat
    background-size: 80px 80px
  }
  .list-wraper {
    height 100%
    width 100%
    border-radius 12px
    overflow hidden
    & ::v-deep .rich-recycle-list {
      // 滚动条撑开 隐藏滚动条
      padding-right 20px
      margin-right -20px
    }
    & ::v-deep .rich-recycle-list-loading {
      display none
    }
    & ::v-deep .rich-recycle-list-noMore {
      display none
    }
  }
  >>> .rich-cell {
    min-height 144px
    .border-bottom-1px {
      border-bottom: 2px solid #EBEBEB
    }
    .rich-cell-title {
      margin-left: 80px
      .rich-cell-text {
        font-family 'Aspira Medium'
        font-size: 32px;
        color: #000000;
        text-align: left;
        font-weight: 500;
      }
      .rich-cell-value {
        font-family 'Aspira Regular'
        font-size 28px
        color #000000
        text-align right
        font-weight 400
      }
      .rich-cell-label {
        position absolute
        width 534px
        height 90px
        font-family 'Aspira Regular'
        font-size 24px
        color #999999
        line-height 30px
        font-weight 400
      }
    }
    .rich-cell-wrapper {
      min-height 144px
      align-items center
      padding-right 20px
      img {
        top auto
      }
      .rich-cell-wrapper:after {
        border-bottom: 1px #e5e5e5 solid
      }
    }
    .rich-cell-wrapper:first-child {
      &:after {
        border-color: #ff0000
        transform: scale(.5)
      }
    }
    &.itm-black {
      .rich-cell-wrapper .rich-cell-value{
        font-family 'Aspira Regular'
        font-size 28px
        color #000000
        text-align right
        font-weight 400
      }
    }
    &.label-cell {
      height 254px
      border-bottom 1px #e5e5e5 solid
      .label {
        position fixed
        left 104px
        top 104px
        width 534px
        height 90px
        font-family 'Aspira Regular'
        font-size 24px
        color #999999
        line-height 30px
        font-weight 400
      }
      .border-bottom-1px {
        border-bottom 0
      }
      .border-bottom-1px:after {
        border-bottom 0
      }
    }
    &.label-cell-lower {
      height 180px
    }
  }
}
.empty-status {
  margin-top: 200px;
  color: #000000;
  display flex;
  align-items: center;
  justify-items: flex-start;
  flex-direction: column;
  img {
    width: 288px;
    height: 288px;
  }
  .empty-title {
    height: 48px;
    line-height: 48px;
    font-family: 'Aspira Medium';
    font-size: 36px;
    text-align: center;
    font-weight: 500;
  }
  .empty-explain {
    margin-top: 5px;
    width: 500px;
    font-family: 'Aspira Light';
    font-size: 24px;
    text-align: center;
    line-height: 30px;
    font-weight: 200;
  }
}
</style>
